import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Trophy, Calendar, Plane, Camera, Award as AwardIcon } from "lucide-react";

const SECTIONS = [
  { id: "awards",       label: "Awards",       icon: Trophy,   note: "Industry & customer awards will appear here." },
  { id: "events",       label: "Events",       icon: Calendar, note: "IBA meets, product launches and rank celebrations." },
  { id: "trips",        label: "Trips",        icon: Plane,    note: "National & International trips earned by achievers." },
  { id: "media",        label: "Media",        icon: Camera,   note: "Press coverage, magazine features and interviews." },
  { id: "achievements", label: "Achievements", icon: AwardIcon,note: "Achiever spotlights and rank crossings." },
];

export default function Gallery() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative bg-royal-deep text-white overflow-hidden">
        <img src="/product-images/home-banner.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-br from-royal-deep via-royal to-navy" />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-[11px] uppercase tracking-[0.4em] text-gold mb-4">Gallery</div>
          <h1 className="font-serif text-5xl leading-tight">Moments that matter.</h1>
          <p className="mt-4 text-white/70 max-w-2xl">Awards · Events · Trips · Media coverage · Achievements — a growing wall of everything Samara Wiz is proud of.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {SECTIONS.map((s) => (
              <a key={s.id} href={`#${s.id}`} data-testid={`gallery-tab-${s.id}`} className="text-xs px-3 py-1.5 border border-white/30 hover:bg-white hover:text-royal-deep rounded-sm uppercase tracking-widest">{s.label}</a>
            ))}
          </div>
        </div>
      </section>

      {SECTIONS.map((s, idx) => (
        <section key={s.id} id={s.id} data-testid={`gallery-${s.id}`} className={`${idx % 2 === 1 ? "bg-cream/40" : "bg-white"} py-20`}>
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-3">
              <s.icon size={18} className="text-gold-deep" />
              <div className="text-[10px] uppercase tracking-[0.3em] text-gold">{s.label}</div>
            </div>
            <h2 className="font-serif text-3xl text-navy">{s.label}</h2>
            <p className="text-navy/60 text-sm mt-2 max-w-2xl">{s.note}</p>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
              {[0, 1, 2, 3].map((i) => (
                <div key={i} data-testid={`gallery-${s.id}-tile-${i}`} className="aspect-square bg-white border border-line rounded-sm overflow-hidden grid place-items-center hover:border-gold/40 transition-colors">
                  <img src="/product-images/coming-soon.svg" alt="" className="w-full h-full object-cover opacity-90" />
                </div>
              ))}
            </div>
            <p className="text-[11px] text-navy/40 mt-4 italic">Real {s.label.toLowerCase()} photos coming soon — admin can upload via the CMS.</p>
          </div>
        </section>
      ))}
      <Footer />
    </div>
  );
}
